module.exports = __webpack_public_path__ + "static/media/YM64_0.1b19df9e.jpg";